<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="redColor text-white d-flex">
        <span class="headline">{{ $t("vehicle_entry.photos") }}</span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- CAMERA -->
          <v-col cols="12" xs="12" md="12" lg="12">
            <camera v-if="dialog" @take-picture="takePicture" />
          </v-col>
          <!-- PHOTOS -->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-row>
              <v-col v-for="(data, index) in photos" :key="index" xs="6" sm="3">
                <v-card
                  flat
                  tile
                  draggable="true"
                  :data-index="index"
                  @dragstart="dragStartHandler"
                  @dragover.prevent
                  @drop="dropHandler"
                  @dragend="dragEndHandler"
                  @mouseenter="hoverIndex = index"
                  @mouseleave="hoverIndex = null"
                >
                  <v-img
                    v-if="data && data.thumb"
                    :src="
                      data && data.thumb
                        ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${data.thumb}`
                        : `https://portal.lekotech.com/logo_small.png`
                    "
                    width="150px"
                    class="mx-1"
                  >
                    <v-row
                      v-if="hoverIndex === index"
                      class="ma-1 d-flex justify-space-between"
                    >
                      <v-icon
                        size="x-large"
                        color="primary"
                        class="pointer"
                        @click="viewImage('string', data)"
                      >
                        mdi-image
                      </v-icon>
                      <v-icon
                        size="x-large"
                        color="red"
                        class="pointer"
                        @click="deleteImage(index)"
                      >
                        mdi-delete-forever
                      </v-icon>
                    </v-row>
                  </v-img>
                  <v-img v-else :src="data.dataUrl">
                    <v-row class="ma-1">
                      <v-icon
                        size="x-large"
                        color="primary"
                        class="pointer"
                        @click="viewImage('dataUrl', data.dataUrl)"
                      >
                        mdi-image
                      </v-icon>
                      <v-spacer />
                      <v-icon
                        size="x-large"
                        color="red"
                        class="pointer"
                        @click="deleteImage(index)"
                      >
                        mdi-delete-forever
                      </v-icon>
                    </v-row>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="outlined" @click="close">
          {{ $t("vehicle_entry.close") }}
        </v-btn>
        <v-btn color="primary" variant="outlined" @click="save">
          {{ $t("vehicle_entry.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Camera from "../camera.vue";

export default {
  components: {
    camera: Camera,
  },
  data() {
    return {
      draggingIndex: -1,
      dropIndex: -1,
      dialog: false,
      photos: [],
      photosToDelete: [],
      hoverIndex: null,
    };
  },
  methods: {
    open(photos) {
      this.dialog = true;
      this.photos = [...photos];
    },
    save() {
      this.$emit("save", {
        photos: this.photos,
        photosToDelete: this.photosToDelete,
      });
      this.close();
    },
    close() {
      this.dialog = false;
      this.photos = [];
      this.photosToDelete = [];
      this.$emit("close");
    },
    takePicture(data) {
      const random = Math.random().toString(36).substring(9);
      const photo = {
        title: `${random}-photo${this.photos.length}.png`,
        dataUrl: data.dataUrl,
        blob: data.blob,
      };
      this.photos.push(photo);
    },
    viewImage(type, data) {
      this.$emit("open-img-dialog", { type, data });
    },
    deleteImage(index) {
      if (typeof this.photos[index] === "string") {
        this.photosToDelete.push(this.photos[index]);
      }
      this.photos.splice(index, 1);
    },
    dragStartHandler(e) {
      this.draggingIndex = parseInt(e.currentTarget.getAttribute("data-index"));
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", null);
    },
    dropHandler(e) {
      e.preventDefault(); // Prevent the browser's default behavior
      this.dropIndex = parseInt(e.currentTarget.getAttribute("data-index"));
      if (this.draggingIndex !== this.dropIndex) {
        const draggedImage = this.photos[this.draggingIndex];
        this.photos.splice(this.draggingIndex, 1);
        if (this.dropIndex > this.draggingIndex) {
          this.photos.splice(this.dropIndex, 0, draggedImage);
        } else {
          this.photos.splice(this.dropIndex, 0, draggedImage);
        }
      }
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },

    dragEndHandler() {
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },

    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
  },
};
</script>
